import { call, put, takeEvery } from "redux-saga/effects";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import * as actions from "./servicesGetActions";
import { decode } from "@p81-common/shell-core-js";
import { DEFAULT_QUERY } from "@p81-common/shell-core-js";

function* servicesGet(action) {
  let params = {
    ...DEFAULT_QUERY,
    ...(action.params || decode()(window.location.search)),
  };
  try {
    let { data } = yield call(requestWithSubTenantIfNeeded, "get", "services", {
      searchParams: {
        ...params,
        ...(params.q
          ? {
              q: JSON.stringify({
                "attributes.name": params.q,
                "attributes.description": params.q,
                "attributes.protocols.value": params.q,
                "attributes.protocols.protocolOptions": params.q,
              }),
              qType: "partial",
            }
          : {}),
      },
    });

    const { services, relationships } = data;

    const collectionsByObjectId = relationships.references.reduce(
      (acc, { sharedObjectId, referenceCollection }) => {
        if (sharedObjectId) (acc[sharedObjectId] ??= []).push(referenceCollection);
        return acc;
      },
      {}
    );

    const servicesWithReferences = {
      ...services,
      data: services.data.map((service) => ({
        ...service,
        references: collectionsByObjectId[service.id] ?? [],
      })),
    };

    yield put(actions.requestSuccess(servicesWithReferences, params));
  } catch (error) {
    yield put(actions.requestFailure(error, params));
  }
}

function* saga() {
  yield takeEvery(actions.SERVICES_GET_REQUEST, servicesGet);
}

export default saga;
